import React, { Component, Fragment } from "react";
import withAssets from "../../../../components/hoc/withAssets";
import { withTranslation } from "react-i18next";
import {
  Controls,
  Form, FormHeader, GelContentColumn,
  GelContentContainer, GelContentRow,
  Notice, TextfieldElement, ButtonSecondary, Role, FormTabs, FormTab, Button
} from "cw-styleguide-react";
import { route } from "../../../../routes";
import {
  OPERATION_TRANSLATE_DRAFT,
  OPERATION_TRANSLATE_AMENDED,
  STATUS_AWAITING_TRANSLATION,
  STATUS_AWAITING_AMENDMENTS,
  STATUS_PUBLISHED,
  LANGUAGE_EN,
  LANGUAGE_CY,
  TRANSLATOR_UNASSIGNED,
  TAB_COURSE_DETAILS,
  TAB_COURSE_SESSIONS,
  ROLE_TRANSLATOR_MANAGER,
} from "../../../../constants";
import ErrorNavigation from "../../../../components/ErrorNavigation";
import WysiwygElement from "../../../../components/WysiwygElement";

class CoursesTranslateSessionsForm extends Component {

  render() {
    return (
      <Form>
        <ErrorNavigation field={this.props.errorActiveField} handleClearActiveErrors={this.props.handleClearActiveErrors} />
        <FormHeader title={this.props.t('local:view.courses.' + this.props.operation + '.tabs.sessions.formHeader.title')}
          introduction={this.props.t('local:view.courses.' + this.props.operation + '.tabs.sessions.formHeader.introduction')} />
        {this.props.values.sessions.map((element, index) => {
          return <Fragment key={index}>
            <h4 className={"style--typography-style--branded-a"}>{this.props.t('local:view.courses.translateDraft.field.session.label')} {element.id}</h4>

            {/* startDetails */}
            {this.props.originalValues['sessions'][index]['startDetails'][LANGUAGE_EN] &&
              <Fragment>
                {this.props.operation === OPERATION_TRANSLATE_AMENDED && this.props.translatableFields.includes('sessions.' + element.id + '.startDetails') && <Notice type={'migration'}>{this.props.t('local:view.courses.translateAmended.requiresTranslation')}</Notice>}
                <GelContentRow>
                  <GelContentColumn md={6}>
                    <div id={'sessions.' + element.id + '.startDetails_en'} />
                    <WysiwygElement
                      id={'startDetails_en'}
                      name={'sessions.' + index + '.startDetails.en'}
                      label={this.props.t('local:view.courses.translateDraft.field.startDetails.label')}

                      value={this.props.values['sessions'][index]['startDetails'][LANGUAGE_EN]}
                      errors={this.props.formErrors['sessions.' + element.id + '.startDetails_en']}
                      onChange={(e) => this.props.handleSetFormValue('sessions.' + index + '.startDetails.en', e.data.get())}
                    />
                  </GelContentColumn>
                  <GelContentColumn md={6}>
                    <div id={'sessions.' + element.id + '.startDetails_cy'} />
                    <WysiwygElement
                      id={'startDetails_cy'}
                      name={'sessions.' + index + '.startDetails.cy'}
                      label={this.props.t('local:view.courses.translateDraft.field.startDetails.label')}
                      value={this.props.values['sessions'][index]['startDetails'][LANGUAGE_CY]}
                      errors={this.props.formErrors['sessions.' + element.id + '.startDetails_cy']}
                      onChange={(e) => this.props.handleSetFormValue('sessions.' + index + '.startDetails.cy', e.data.get())}


                      descriptionAfter={<Button asLink={true} onClick={(event) => { this.props.translateCourseField(event, 'sessions.' + index + '.startDetails') }} title={`${this.props.t('styleguide:forms.translate')} ${this.props.t('local:view.courses.translateDraft.field.startDetails.label')}`}>{this.props.t('styleguide:forms.translate')}</Button>}

                    />
                  </GelContentColumn>
                </GelContentRow>
              </Fragment>
            }

            {/* daysTimes */}
            {this.props.originalValues['sessions'][index]['daysTimes'][LANGUAGE_EN] &&
              <Fragment>
                {this.props.operation === OPERATION_TRANSLATE_AMENDED && this.props.translatableFields.includes('sessions.' + element.id + '.daysTimes') && <Notice type={'migration'}>{this.props.t('local:view.courses.translateAmended.requiresTranslation')}</Notice>}
                <GelContentRow>
                  <GelContentColumn md={6}>
                    <div id={'sessions.' + element.id + '.daysTimes_en'} />
                    <WysiwygElement
                      id={'daysTimes_en'}
                      name={'sessions.' + index + '.daysTimes.en'}
                      label={this.props.t('local:view.courses.translateDraft.field.daysTimes.label')}

                      value={this.props.values['sessions'][index]['daysTimes'][LANGUAGE_EN]}
                      errors={this.props.formErrors['sessions.' + element.id + '.daysTimes_en']}
                      onChange={(e) => this.props.handleSetFormValue('sessions.' + index + '.daysTimes.en', e.data.get())}
                    />
                  </GelContentColumn>
                  <GelContentColumn md={6}>
                    <div id={'sessions.' + element.id + '.daysTimes_cy'} />
                    <WysiwygElement
                      id={'daysTimes_cy'}
                      name={'sessions.' + index + '.daysTimes.cy'}
                      label={this.props.t('local:view.courses.translateDraft.field.daysTimes.label')}
                      value={this.props.values['sessions'][index]['daysTimes'][LANGUAGE_CY]}
                      errors={this.props.formErrors['sessions.' + element.id + '.daysTimes_cy']}
                      onChange={(e) => this.props.handleSetFormValue('sessions.' + index + '.daysTimes.cy', e.data.get())}

                      descriptionAfter={<Button asLink={true} onClick={(event) => { this.props.translateCourseField(event, 'sessions.' + index + '.daysTimes') }} title={`${this.props.t('styleguide:forms.translate')} ${this.props.t('local:view.courses.translateDraft.field.daysTimes.label')}`}>{this.props.t('styleguide:forms.translate')}</Button>}

                    />
                  </GelContentColumn>
                </GelContentRow>
              </Fragment>
            }

          </Fragment>
        })}
      </Form>
    )
  }
}

export default withAssets(withTranslation('local')(CoursesTranslateSessionsForm));
